import { render } from "./App.vue?vue&type=template&id=377f4d5c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./styles/theme.styl?vue&type=style&index=0&lang=stylus"
import "./App.vue?vue&type=style&index=1&id=377f4d5c&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__